import { css } from 'lit';
export default css `
  :host {
    --private-skeleton-width: 600px;
    --private-skeleton-height: 20px;
    --private-skeleton-border-radius: 10px;
  }

  /*For Skeleton Loading */
  .skeleton {
    background: #eee;
    background: linear-gradient(110deg, #ececec 8%, var(--amityeko-color-gray-9) 18%, #ececec 33%);
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
  }

  .skeleton--default {
    width: var(--private-skeleton-width);
    height: var(--private-skeleton-height);
    border-radius: var(--private-skeleton-border-radius);
  }

  .skeleton--circle {
    width: var(--private-skeleton-width);
    height: var(--private-skeleton-height);
    border-radius: 50%;
  }

  .skeleton--square {
    width: var(--private-skeleton-width);
    height: var(--private-skeleton-height);
  }

  .skeleton--rounded {
    width: var(--private-skeleton-width);
    height: var(--private-skeleton-height);
    border-radius: var(--amityeko-radius-small);
  }

  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }
`;
//# sourceMappingURL=styles.js.map